/**
 * Константы для OnSaleLoader
 * Централизованное хранение всех магических значений
 */
export const ONSALE_CONSTANTS = {
  // Модель
  MODEL_PATH: 'models/onsale.glb',

  // Масштаб модели
  MODEL_SCALE: 5,

  // Позиция объекта
  OBJECT_POSITION_Y: 3,

  // Параметры добавления объекта
  OBJECT_ALTITUDE: 0,
  OBJECT_SCALE: 7,

  // Префикс для ID объектов
  OBJECT_ID_PREFIX: 'onsale-',
} as const
